module.exports = __webpack_public_path__ + "img/5.117e5c83.svg";